import React from "react";
import { PlatformFeature } from "@ecologi/shared";
import { HoldingPage } from "@ecologi/react-components/src/HoldingPage";
import { ConsumerPlansPage } from "../features/";
import { withFeatureFlagGuard } from "../lib/auth/with-feature-flag-guard";

export default withFeatureFlagGuard(ConsumerPlansPage, HoldingPage, {
  [PlatformFeature.Maintenance]: false,
});
